import { RouteItem } from '@eastcoal/router/types/route'

import { PRICE_COMPARE_LIST_PAGE_PATH } from './constant/path'
import { PRICE_COMPARE_LIST_PAGE_UUID } from './constant/uuid'

export const priceCompareListRoute: RouteItem = {
  title: '比价采购',
  path: PRICE_COMPARE_LIST_PAGE_PATH,
  uuid: PRICE_COMPARE_LIST_PAGE_UUID,
  hideChildrenInMenu: true,
  Component: () => import('./List/index')
}
